import React, { useMemo } from 'react';
import ReactMarkdown from 'react-markdown';
import { Link } from 'react-router-dom';
import remarkGfm from 'remark-gfm';

import { SummaryEntry } from 'main/changelog';
import formatDate from 'main/components/utils/format-date';

import useStyles from './styles';

interface Props {
    entry: SummaryEntry;
    className?: string;
}

const Card: React.FC<Props> = ({ entry, className }) => {
    const { classes, cx } = useStyles();

    const colors = useMemo(
        () => [classes._blue, classes._green, classes._yellow, classes._pink, classes._cyan],
        [classes]
    );

    return (
        <Link to={`/changelog/${entry.id}`} className={cx(classes.root, className)}>
            <div className={classes.heading}>
                <p className={classes.title}>{entry.title}</p>
                <span className={classes.date}>{formatDate(entry.date, 'MMMM d, yyyy')}</span>
            </div>
            <div className={classes.content}>
                <ReactMarkdown remarkPlugins={[remarkGfm]}>{entry.shortContent}</ReactMarkdown>
            </div>
            <div className={classes.tags}>
                {entry.tags.map((tag, index) => {
                    return (
                        <span key={index} className={cx(classes.tag, colors[index % colors.length])}>
                            {tag}
                        </span>
                    );
                })}
            </div>
        </Link>
    );
};

export default Card;
